(function (wtcpJs) {
    "use strict";
    class AnchorInfo {

        constructor() {
            this.value = 0;
            this.type = 0;
            this.before = 0;
            this.after = 0;
        }
    }

    wtcpJs.AnchorInfo = AnchorInfo;
})(WtcpJs || (WtcpJs = {}));